import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';

import { FloatingModal } from '../Modal';
import { extendLanguage, getFlagImage } from '../../../../helpers';
import { findLanguage, localeData } from '../../../../i18n';
import { update } from '../../../../ducks/app';
import styles from './language-select.scss';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  availableLanguages: PropTypes.arrayOf(PropTypes.string),
  language: PropTypes.string,
};

class LanguageSelect extends React.Component {
  constructor() {
    super();
    this.state = {
      modalOpen: false,
    };
  }

  openModal = () => {
    this.setState({
      modalOpen: true,
    });
  }

  closeModal = () => {
    this.setState({
      modalOpen: false,
    });
  }

  changeLanguage = (lang) => {
    const { dispatch } = this.props;
    dispatch(update({ language: lang }));
    this.closeModal();
  }

  render() {
    const {
      language,
      availableLanguages = Object.keys(localeData),
    } = this.props;
    const { modalOpen } = this.state;
    const activeLanguage = language || findLanguage();
    const filteredLanguage = availableLanguages
      .find((availableLanguage) => availableLanguage === activeLanguage) || 'en';

    return (
      <div
        className={styles.select}
      >
        <div
          role="button"
          tabIndex={0}
          className={styles.activeLang}
          onClick={() => this.openModal()}
        >
          <img
            alt=""
            src={getFlagImage(filteredLanguage)}
          />
          <span>{extendLanguage(filteredLanguage)}</span>
        </div>
        <FloatingModal
          isOpen={modalOpen}
          onRequestClose={() => this.closeModal()}
        >
          <div className={styles.modal}>
            <div className={styles.title}>
              Choose language
            </div>
            <div className={styles.list}>
              { availableLanguages.slice().sort().map((langOption) => (
                <div
                  className={styles.option}
                  key={langOption}
                  role="button"
                  tabIndex={0}
                  onClick={() => this.changeLanguage(langOption)}
                >
                  <img
                    alt=""
                    src={getFlagImage(langOption)}
                  />
                  <span>{extendLanguage(langOption)}</span>
                  { filteredLanguage === langOption
                    && <i className="far fa-check" />}
                </div>
              )) }
            </div>
          </div>
        </FloatingModal>
      </div>
    );
  }
}

LanguageSelect.propTypes = propTypes;

function mapStateToProps(state) {
  return {
    language: state.getIn(['app', 'language']),
  };
}

export default connect(mapStateToProps)(LanguageSelect);
